
import AdminSideBar from '../../components/adminSideBar/AdminSideBar';
import StatistiquesAujourdhui from '../../components/statistiques/statistiquesAujourdhui/StatistiquesAujourdhui';
import './home.css';

function Home() {
  return (
    // test
    <div className='container-global'>
      <AdminSideBar activeTab="home" />
      <div className='center'>
        <div className="title">
          <span className="material-symbols-rounded">shoppingmode</span>
          <span>Dashboard</span>
        </div>
 
        <StatistiquesAujourdhui />
      </div>
    </div>
  )
}
export default Home